import { render, staticRenderFns } from "./JournalObjectSelect.vue?vue&type=template&id=6132a744"
import script from "./JournalObjectSelect.vue?vue&type=script&lang=ts"
export * from "./JournalObjectSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports